module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'da6i9l2g',
    dataset: process.env.GATSBY_SANITY_DATASET || 'development',
  },
}
